/**
 * Presentation Library
 *
 * All available presentations for the securesight.ai platform
 */

import type { PresentationData } from '../../types/presentation'
import { professionalLayoutsDemo } from './professional-layouts-demo'
import { developerTrainingDay1 } from './developer-training-day1'
import { entwicklerschulungTag1 } from './entwicklerschulung-tag1'
import { contextEngineeringProfessionalDe } from './context-engineering-professional-de'
import { contextEngineeringProfessionalEn } from './context-engineering-professional-en'
import { erstgespraech } from './erstgespraech'
import { erstgespraechEn } from './erstgespraech-en'

export { professionalLayoutsDemo }
export { developerTrainingDay1 }
export { entwicklerschulungTag1 }
export { contextEngineeringProfessionalDe }
export { contextEngineeringProfessionalEn }
export { erstgespraech }
export { erstgespraechEn }

// Presentation metadata for listing
export interface PresentationMeta {
  id: string
  title: string
  description: string
  author: string
  date: string
  tags: string[]
  slides: number
  file: string
  accessLevel: 'demo' | 'company' | 'admin'
  language?: string
  slideCount: number
  createdAt: string
  updatedAt: string
}

// Presentation metadata for listing
export const presentations: PresentationMeta[] = [
  {
    id: 'professional-layouts-demo',
    title: 'Professional Slide Layouts Demo',
    description: 'Showcasing modern, professional presentation layouts',
    author: 'Design Team',
    date: 'Oktober 2025',
    tags: ['Design System', 'Layouts', 'Professional', 'Demo'],
    slides: 7,
    file: 'professional-layouts-demo',
    accessLevel: 'demo',
    slideCount: 7,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'developer-training-day1',
    title: 'AI Developer Training Day 1',
    description: 'AI Fundamentals & AI Coding Tools for Developers',
    author: 'AI Experts & Development Consultants',
    date: 'October 2025',
    tags: ['AI', 'AI Tools', 'Development', 'Workshop'],
    slides: 15,
    file: 'developer-training-day1',
    accessLevel: 'demo',
    slideCount: 15,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'entwicklerschulung-tag1',
    title: 'KI-Entwicklerschulung Tag 1',
    description: 'KI-Grundlagen & AI-Coding-Tools für Entwickler',
    author: 'KI-Experten & Entwicklungs-Consultants',
    date: 'Oktober 2025',
    tags: ['KI', 'AI-Tools', 'Entwicklung', 'Workshop'],
    slides: 39,
    file: 'entwicklerschulung-tag1',
    accessLevel: 'demo',
    slideCount: 39,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'context-engineering-professional-de',
    title: 'Context Engineering - Professionelle Grundlagen',
    description: 'Systematische Methodik für effiziente KI-Entwicklung',
    author: 'Jan Pfrommer',
    date: 'Oktober 2025',
    tags: ['Context Engineering', 'KI-Entwicklung', 'Enterprise', 'Systematisch'],
    slides: 15,
    file: 'context-engineering-professional-de',
    accessLevel: 'demo',
    language: 'de',
    slideCount: 15,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'context-engineering-professional-en',
    title: 'Context Engineering - Professional Foundations',
    description: 'Systematic methodology for efficient AI development',
    author: 'Jan Pfrommer',
    date: 'October 2025',
    tags: ['Context Engineering', 'AI Development', 'Enterprise', 'Systematic'],
    slides: 15,
    file: 'context-engineering-professional-en',
    accessLevel: 'demo',
    language: 'en',
    slideCount: 15,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'erstgespraech',
    title: 'KI-Beratung Erstgespräch',
    description: 'Strukturiertes Erstgespräch für KI-Beratung und RAG-Systeme',
    author: 'Jan Pfrommer & Kai Bennett',
    date: '2025',
    tags: ['AI', 'Consulting', 'RAG', 'Business'],
    slides: 14,
    file: 'erstgespraech',
    accessLevel: 'demo',
    language: 'de',
    slideCount: 14,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
  {
    id: 'erstgespraech-en',
    title: 'AI Consulting Initial Meeting',
    description: 'Initial consultation presentation for AI advisory services',
    author: 'Jan Pfrommer & Kai Bennett',
    date: '2025',
    tags: ['AI', 'Consulting', 'RAG', 'Business'],
    slides: 14,
    file: 'erstgespraech-en',
    accessLevel: 'demo',
    language: 'en',
    slideCount: 14,
    createdAt: '2025-10-01T00:00:00.000Z',
    updatedAt: '2025-10-01T00:00:00.000Z',
  },
]

// Create a mapping for easy lookup by ID with proper typing for dynamic indexing
export const allPresentations: Record<string, PresentationData> = {
  'professional-layouts-demo': professionalLayoutsDemo,
  'developer-training-day1': developerTrainingDay1,
  'entwicklerschulung-tag1': entwicklerschulungTag1,
  'context-engineering-professional-de': contextEngineeringProfessionalDe,
  'context-engineering-professional-en': contextEngineeringProfessionalEn,
  'erstgespraech': erstgespraech,
  'erstgespraech-en': erstgespraechEn,
}

export default {
  professionalLayoutsDemo,
  developerTrainingDay1,
  entwicklerschulungTag1,
  contextEngineeringProfessionalDe,
  contextEngineeringProfessionalEn,
  erstgespraech,
  erstgespraechEn,
}
